export default {
    title: 'Affiliate',
    my_affiliate_info: 'My Affiliate Info',
    my_target_referer: 'My Target Referer',
    affiliate_code: 'Affiliate Code',
    affiliate_link: 'Affiliate Link',
    affiliate_hint:
        'Copy your CODE or LINK and send it to your friends to get rewards',
    affiliate_target:
        'You will receive a commission of {commissionAmount} per referral once they reach a minimum spending of {earnLimit}.',
    note: "Note: Commission is paid in promo credits to purchase 1Byte's services",
    earned_promo_credit: 'Earned Promo Credit',
    referees: 'Referees',
    registration_date_from: 'Registration date from',
    due_date_from: 'Due date from',
    issue_date_from: 'Issue date from',
    target_from: 'Target amount from',
    earned_from: 'Earned amount from',
    username: 'Username',
    registration_date: 'Registration date',
    due_date: 'Due date',
    issue_date: 'Issue date',
    target: 'Target',
    earned: 'Earned',
    reward: 'Reward',
    referer_target_note:
        'You will receive a commission of {amount} when you reach the target.',
};
